import { Injectable, inject } from "@angular/core";
import { LorenReportsEndpointsService } from "../loren-reports-endpoints-service/loren-reports-endpoints.service";
import { LorenAggregate } from "../../../../shared/enums/loren-aggregate.enum";
import { LorenAssetMetering } from "../../components/loren-asset-reports/interfaces/loren-asset-metering.interface";
import { LorenMetricCategories } from "../../../../shared/modules/loren-asset-card/constants/loren-metric-types.constants";
import { HttpClient } from "@angular/common/http";
import { Instant } from "@js-joda/core";

@Injectable({
  providedIn: "root",
})
export class LorenReportsService {
  private endpointsService = inject(LorenReportsEndpointsService);
  private http = inject(HttpClient);

  exportDataInXLS(
    type: LorenMetricCategories,
    meteringIds: string[],
    dateFrom: Instant,
    dateTo: Instant,
    aggregateTo: LorenAggregate = null
  ) {
    const urlFn =
      type === LorenMetricCategories.NUMERIC
        ? this.endpointsService.exportNumericData
        : type === LorenMetricCategories.BINARY
        ? this.endpointsService.exportBinaryData
        : this.endpointsService.exportPresenceData;
    const url = urlFn(meteringIds, dateFrom, dateTo, aggregateTo);
    return this.http.get(url, { responseType: 'blob' });
  }

  // exportSoilData(meteringIds: string[], dateFrom: Dayjs, dateTo: Dayjs, aggregateTo: LorenAggregate) {
  //     const url = this.endpointsService.exportSoilData(meteringIds, dateFrom, dateTo, aggregateTo);
  //     return this.http.get<any>(url, {responseType: LorenContentTypes.BLOB});
  // }

  exportDataInPDF(
    assetMetering: LorenAssetMetering[],
    dateFrom: Instant,
    dateTo: Instant
  ) {
    const url = this.endpointsService.exportPDFData();
    const data = {
      dateFrom: dateFrom.toString(),
      dateTo: dateTo.toString(),
      assetMetering,
    };
    return this.http.post(url, data, { responseType: 'blob' });
  }

  exportDevicesReport() {
    const url = this.endpointsService.exportDevicesReport();
    return this.http.get(url, { responseType: 'blob' });
  }

  getSMSNumber() {
    return this.http.get(this.endpointsService.getSMSNumber(), {});
  }
}
